__turbopack_context__.v({
  "band": "qqiTsG_band",
  "bg": "qqiTsG_bg",
  "bgImg": "qqiTsG_bgImg",
  "bgScrim": "qqiTsG_bgScrim",
  "card": "qqiTsG_card",
  "copy": "qqiTsG_copy",
  "ctas": "qqiTsG_ctas",
  "eyebrow": "qqiTsG_eyebrow",
  "figure": "qqiTsG_figure",
  "heading": "qqiTsG_heading",
  "lede": "qqiTsG_lede",
  "ledeLong": "qqiTsG_ledeLong",
  "ledeShort": "qqiTsG_ledeShort",
  "section": "qqiTsG_section",
  "visual": "qqiTsG_visual",
});
